import { ExternalQuestionnaire } from "@app/screens/ExternalQuestionnaires/externalQuestionnaire";
import { useQuestionnaireHeaderData } from "@app/screens/ExternalQuestionnaires/externalQuestionnaire/data";
import { HeaderFullSkeleton } from "@app/shared/components/BackgroundedHeader";
import { useMemo, useState, type FC } from "react";
import { useParams } from "react-router-dom";
import { useProjectBreadcrumb } from "./useProjectBreadcrumb";
import { EditOrDeleteProjectModal } from "./EditOrDeleteProjectModal";

export const FrameworkProject: FC = () => {
    const { framework_project_id } = useParams();

    useProjectBreadcrumb();

    return <FrameworkQuestionnaire frameworkId={framework_project_id ?? ""} />;
};

const FrameworkQuestionnaire: FC<{ frameworkId: string }> = ({
    frameworkId,
}) => {
    const { questionnaireHeaderData } = useQuestionnaireHeaderData(frameworkId);
    const [openEditModal, setOpenEditModal] = useState(false);

    const options = useMemo(
        () => ({
            canEditQuestions: false,
            frameworkCmsId: questionnaireHeaderData?.cmsId ?? "",
            onEditClick: () => setOpenEditModal(true),
            canSetQuestionsIrrelevant: true,
            canDeleteQuestions: false,
        }),
        [questionnaireHeaderData?.cmsId],
    );

    if (!questionnaireHeaderData) {
        return <HeaderFullSkeleton />;
    }

    return (
        <>
            <ExternalQuestionnaire id={frameworkId} options={options} />
            <EditOrDeleteProjectModal
                open={openEditModal}
                onOpenChange={setOpenEditModal}
                projectId={frameworkId}
            />
        </>
    );
};
